<template>
  <div v-if="visible">
    <el-dialog title="提示" :visible.sync="visible" width="50%" @close="close">
      <div class="d-t-w">
        <div class="text-left">标签名称</div>
        <div class="c-i">
          <el-input size="small" placeholder="请输入名称" v-model="name" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "OssUploadExample",

  components: {},

  props: {},

  data() {
    return {
      loading: false,
      visible: false,
      action: "",
      imageUrl: null,
      name: "",
      objectKey: "",
      id: 0,
    };
  },
  computed: {},
  mounted() {},

  methods: {
    setValue(obj) {
      this.visible = true;
      if (typeof obj != "undefined") {
        this.name = obj.name;
        this.id = obj.id;
      } else {
        this.name = "";
        this.id=0
      }
    },
    async handleSure() {
      if (this.name == "") {
        this.$message.warning("请输入内容");
        return;
      }
      this.loading = true;
      if (this.id == 0) {
        try {
          let r = await axios.post("/admin/add-label", { name: this.name });
          if (r.code == 0) {
            this.$message({
              type: "success",
              message: "新增成功",
            });
          } else {
          }
        } catch (e) {}
      } else {
        try {
          let r = await axios.post("/admin/edit-label", {
            name: this.name,
            id: this.id,
          });
          if (r.code == 0) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
          } else {
          }
        } catch (e) {}
      }

      this.loading = false;
      this.visible = false;
      this.$emit("success");
    },
    handleCancel() {
      this.visible = false;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}

.avatar {
  width: 128px;
  height: 128px;
  display: block;
}
.d-t-w {
  display: flex;
  align-items: center;
  justify-content: center;
}
.u-w {
  border: 1px solid #ffd04b;
}
.c-i {
  margin-left: 12px;
}
.c-i-u {
  margin-left: 36px;
}
.m-d {
  margin-top: 20px;
}
.text-left {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/component/LabelDialog.vue